import { useCallback } from "react";
import { queryKeys } from "../constants/constans";
import { useQuery, useQueryClient } from "react-query";
import { StaffType } from "../types/StaffType";

export default function useUpdateTable() {
  const queryClient = useQueryClient();
  const { data: isUpdate }: any = useQuery(queryKeys.updateTable, () =>
    queryClient.getQueryData(queryKeys.updateTable)
  );
  const setValueUpdate = useCallback(
    (isUpdate: string | null) =>
      queryClient.setQueryData(queryKeys.updateTable, isUpdate),
    [queryClient]
  );

  return { isUpdate: isUpdate || null, setValueUpdate };
}
